import {
    SelectAsyncWrapper,
    SelectWrapper,
    InputDateWrapper,
} from '../../../../../../../components/UI/Form/Input'
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { SelectOption } from '../../../../../../../models/utility.model'
import { Button, ButtonWrapper } from '../../../../../../../components/UI/Button'
import {useCamp, useClient, useCompany, useSite} from '../../../../../../central/hooks'

export const FormHeaderDeliveryClothes = ({
    selectedOption,
    submitFn,
}: any) => {

    const methods = useForm<any>()

    const { handleSubmit, setValue, watch, setError } = methods
    
    const {getCompanyFD} = useCompany()
    const {getClientFD} = useClient()
    const {getSiteFD} = useSite()
    const {getCampFD} = useCamp()

    const [searching, setSearching] = useState<boolean>(false)
    const [company, setCompany] = useState<SelectOption[]>([])
    const [client, setClient] = useState<SelectOption[]>([])
    const [sites, setSites] = useState<SelectOption[]>([])
    const [camps, setCamps] = useState<SelectOption[]>([])

    const getCompaniesFn = async () => {
        const data = await getCompanyFD({})
        if (data.length === 1) {
            setValue('CompaniaId', data[0].value as string)
            setError('CompaniaId', {})
            await getClientsFn(data[0].value as string)
        }
        setCompany(data)
    }
    const getClientsFn = async (companyId: string) => {
        const data = await getClientFD({companiaId: companyId})
        if (data.length === 1) {
            setValue('ClienteId', data[0].value as string)
            setError('ClienteId', {})
            await getSitesFn(data[0].value as string)
        }
        setClient(data)
    }
    const getSitesFn = async (clientId: string) => {
        const data = await getSiteFD({ clienteId: clientId})
        if (data.length === 1) {
            setValue('SiteId', data[0].value as string)
            setError('SiteId', {})
            await getCampsFn(data[0].value as string)
        }
        setSites(data)
    }
    const getCampsFn = async (siteId: string) => {
        const data = await getCampFD({ siteId: siteId })
        if (data.length === 1) {
            setValue('CampamentoId', data[0].value as string)
            setError('CampamentoId', {})
        }
        const allData = [{ value: '4EsB2NAAsDA=', label: 'TODOS' }, ...data]
        setCamps(allData)
    }

    const getInformationUser = async (e: any) => {
        let value = e ? e : ''
        setValue('UsuarioId', value.value)
        setValue('Usuario_descripcion', value.label)
    }

    const loadOptionsGuest = async (inputValue: string, callback: (options: any[]) => void) => {
        try {
            if (inputValue.length < 3) { return [] }
            return []
            // const { data: response } = await getFilterGuestOccupancyReportDTableList({
            //   FechaInicio: watch('nroDiaFin') || '',
            //   SiteId: watch('SiteId') || null,
            //   CampamentoId: watch('CampamentoId') || null,
            //   BuscaTexto: inputValue,
            // })
            // if (response.length > 0) {
            //   const mappedGuests = response?.map((guest: any) => ({
            //     value: guest.HuespedId,
            //     label: `${guest.HuespedNombres} ${guest.HuespedApPaterno} ${guest.HuespedApMaterno} ${guest.HuespedNroDoc}`,
            //     ...guest,
            //   }))
            //   return mappedGuests
            // } else {
            //   return []
            // }
        } catch (error) {
            console.error('Error fetching options:', error)
            return []
        }
    }

    const handleCompanyChange = (val: any) => {
        let value = val ? val.value : ''
        setValue('CompaniaId', value)
        setValue('ClienteId', '')
        setValue('SiteId', '')
        setSites([])
        setValue('CampamentoId', '')
        setCamps([])
        setError('CompaniaId', {})
        getClientsFn(value)
    }
    const handleClientChange = (val: any) => {
        let value = val ? val.value : ''
        setValue('ClienteId', value)
        setValue('SiteId', '')
        setValue('CampamentoId', '')
        setCamps([])
        setError('ClienteId', {})
        getSitesFn(value)
    }
    const handleSiteChange = (val: any) => {
        let value = val ? val.value : ''
        setValue('SiteId', value)
        setValue('CampamentoId', '')
        setError('SiteId', {})
        getCampsFn(value)
    }
    const handleClear = () => {
        console.log("CLEAR")
        // reset()
        // setClient([])
        // setSites([])
        // setCamps([])
    }

    const onSubmit = async (dataForm: any) => {
        console.log("SUBMIT =>", dataForm)
        setSearching(true)
        setSearching(false)
    }

    useEffect(() => {
        getCompaniesFn()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <FormProvider {...methods}>
            <form className='m-2'>
                <div className='row'>
                    <div className='col-sm-12 col-lg-3'>
                        <SelectWrapper
                            labelText='Compañia'
                            name='CompaniaId'
                            data={company}
                            onChangeValue={handleCompanyChange}
                            required
                        />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                        <SelectWrapper
                            labelText='Cliente'
                            name='ClienteId'
                            data={client}
                            onChangeValue={handleClientChange}
                            required
                        />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                        <SelectWrapper
                            labelText='Site'
                            name='SiteId'
                            data={sites}
                            onChangeValue={handleSiteChange}
                            required
                        />
                    </div>
                    <div className='col-sm-12 col-lg-3'>
                        <SelectWrapper
                            labelText='Campamento'
                            name='CampamentoId'
                            data={camps}
                            required
                        />
                    </div>
                    <div className='col-lg-6'>
                        <SelectAsyncWrapper
                            labelText='Usuario Auxiliar'
                            keySelect={`${watch('SiteId')}-${watch('CampamentoId')}`}
                            name='UsuarioId'
                            loadOptions={loadOptionsGuest}
                            onChangeValue={getInformationUser}
                            value={{
                                value: watch('UsuarioId') || '',
                                label: watch('Usuario_descripcion') || '',
                            }}
                        />
                    </div>
                    <div className='col-lg-3'>
                        <InputDateWrapper labelText='Fecha de Entrega' name='fechaEntrega' />
                    </div>
                    <div className='col-lg-3'>
                        <ButtonWrapper className={'sdx-white-bg'}>
                            <Button label='Limpiar' onClick={handleClear} />
                        </ButtonWrapper>
                    </div>
                </div>
            </form>
        </FormProvider>
    )
}
